/**
 * Legacy OfflineService module — preserved as an empty AngularJS module so
 * existing dependencies (`acme.common.service.offline`) keep resolving.
 *
 * The actual `OfflineService` is now an Angular 18 class registered as a
 * downgraded factory under the same name in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 *
 * Implementation:
 *   apps/b2b-frontend/app/core/api/offline/offline.service.ts
 *
 * Do NOT register `.provider('OfflineService', ...)` here — it would shadow
 * the downgraded service.
 */
angular.module('acme.common.service.offline', []);
